import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../configurator/services/data.service';

@Component({
  selector: 'app-debug',
  templateUrl: './debug-technic.component.html',
  styleUrls: ['./debug-technic.component.css'],
})
export class DebugTechnicComponent implements OnInit {
  constructor(public data: DataService) {}

  ngOnInit(): void {}
}
